import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import otpimg from "../../assets/images/enterotp.svg";
import logowhite from "../../assets/images/logowhite.svg";
import Images from "assets/images";
import { authService } from "services";

const Enterotp = () => {
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [otp, setOtp] = useState({});
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('userData'));
  const [searchParams] = useSearchParams();
  const verifyType = searchParams.get("type");
  const [timer, setTimer] = useState(30);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const LIVE_SITE_URL = process.env.REACT_APP_LIVE_SITE_URL;
  const handleRequestOtp = async () => {
    const payload = {
      countryCode: userData?.countryCode,
      phone: userData?.phone,
      roleType: userData?.roleType

    }
    try {
      const response = await authService.requestotp(payload);
      setMessage(response?.data?.message);
      setTimeout(() => setMessage(null), 2000);
    } catch (err) {
      console.log(err)
    }
    setTimer(30);
    setIsTimerRunning(true);
  }

  const handleSubmit = async () => {
    const otpData = Object.values(otp).filter(item => item);
    if (otpData.length !== 4) {
      setError("Please enter otp")
      return;
    }
    setError(null);
    const payload = {
      type: verifyType,
      phone: userData?.phone,
      otp: otpData.join(""),
      deviceToken: '',
      roleType: userData?.roleType,
    }
    try {
      const response = await authService.verifyotp(payload);
      if (response?.data?.data?.token) {
        localStorage.setItem('userData', JSON.stringify(payload));
        localStorage.setItem('token', response?.data?.data?.token);
        navigate(`/verify-otp?type=${verifyType}`);
      }

      if (response?.data?.success === false) {
        setError(response?.data?.message);
      }
    } catch (err) {
      console.error(err?.response?.data?.message);
      setError(err?.response?.data?.message);
    }
  }

  const handleOTPChange = (e) => {
    if (e.target.previousSibling && e.keyCode === 8) {
      e.target.previousSibling.focus();
    }
    setOtp({
      ...otp,
      [e.target.name]: e.target.value
    })
    if (e.target.nextSibling && e.target.value) {
      e.target.nextSibling.focus();
    }
  }

  useEffect(() => {
    const keyDownHandler = event => {
      if (event.key === 'Enter') {
        handleSubmit();
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [otp]);

  useEffect(() => {
    let countdown;

    if (isTimerRunning) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    return () => clearInterval(countdown);
  }, [isTimerRunning]);

  useEffect(() => {
    if (timer === 0) {
      setIsTimerRunning(false);
    }
  }, [timer]);

  return (
    <>
      <div className="container-fluid login-page p-0">
        <div className="row relative">
          <div className="col-lg-7 pr-0">
            <div className="right-login-side">
              <div className="nav-bar-container">
                <Link to="/" className="nav-bar">
                  <img alt="" src={Images.arrowleft} className="me-2 py-1" />
                  Home
                </Link>
              </div>

              <div className="outer-div-form">
                <div className="form-div">
                  <img alt='' src={otpimg} className="img-otp mx-auto d-block" />
                  <h4 className="text-center text-white form-hreading fw-bold">Verify Account</h4>
                  <div className="tab-content-bg">
                    <div className="tab-content auth-tab-content px-lg-5 px-3">
                      <p className="text-center mx-auto">
                        A 4 digit verification code has been sent to your mobile number
                      </p>
                      <div className="verification-code">
                        <div className="verification-code--inputs">
                          <input name="otp-1" type="text" maxLength={1} onKeyUp={handleOTPChange} autoFocus />
                          <input name="otp-2" type="text" maxLength={1} onKeyUp={handleOTPChange} />
                          <input name="otp-3" type="text" maxLength={1} onKeyUp={handleOTPChange} />
                          <input name="otp-4" type="text" maxLength={1} onKeyUp={handleOTPChange} />
                          {error && <div className="text-danger">{error}</div>}
                          {message && <div className="text-success">{message}</div>}
                        </div>
                      </div>
                      <div className="text-center">
                        <button className="btn btn-primary text-capitalize" onClick={handleSubmit}>Verify code</button>
                      </div>

                      <div className="text-center mt-3">
                        <span className="light-text text-white">Didn't Receive?</span>{" "}
                        <button
                          className="text-decoration-none fw-bold text-white bg-transparent border-0"
                          onClick={() => {
                            if (!isTimerRunning) {
                              setIsTimerRunning(true);
                            }
                            handleRequestOtp();
                          }}
                          disabled={isTimerRunning}
                        >
                          {isTimerRunning ? `Wait for ${timer} seconds` : 'Request Again'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex mt-md-0 mt-2 flex-md-row flex-column bottom-ft justify-content-between auth-bottom-links">
                <div className="mb-lg-0 mb-3 d-flex justify-content-md-start justify-content-center">
                  <Link to={`${LIVE_SITE_URL}terms-conditions`}>Terms of Services</Link>
                  <Link to={`${LIVE_SITE_URL}privacy-policy`}>Privacy Policy</Link>
                </div>
                <div className="mb-lg-0 mb-3 d-flex justify-content-md-end justify-content-center">
                  <p>© 2023 SkyyTask. All rights reserved.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-5 pl-0 pr-0 pt-0">
            <div className="left-bg-form">
              <div className="logo-container w-100">
                <Link to="/" className="mx-auto mt-4 d-flex justify-content-center">
                  <img alt="" src={logowhite} className="logo" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Enterotp;
